import React, {useEffect, useMemo, useRef, useState} from 'react'
import PropTypes from "prop-types"
import {
  errorMessage,
  getEffectDependencies,
  getValue,
  isInvalid,
  onBlur,
  onChange
} from "./Component";
import {CountryNamesCodes} from "../../assets/flags/Countries";
import { GlobeSVG } from '../../assets/flags/Globe';
import Fragment from "./Fragment";

const PhoneNumber = props => {

  const [value, setValue] = useState(getValue(props));
  const [showMenu, setShowMenu] = useState(false);
  const [selectedCountryCodeValue, setselectedCountryCodeValue] = useState(null);
  const [searchCountryCodeValue, setSearchCountryCodeValue] = useState("");

  const searchRef = useRef();
  const inputRef = useRef();
  const inputRefCountryCode = useRef();

  const phoneRegex = useMemo(() => {
    return new RegExp("^\\+?(\\d?)+$")
  }, []);

  useEffect(() => {
    setValue(getValue(props))

    setselectedCountryCodeValue(null);

    for (const item of CountryNamesCodes) {
      if (getValue(props).startsWith(item.code)) {
        setselectedCountryCodeValue(item);
        break;
      }
    }

  }, [...getEffectDependencies(props)]);

  useEffect(() => {
    props.focus && inputRef.current?.focus && inputRef.current.focus();
  }, [props.focus]);


  useEffect(() => {

    const handler = (e) => {
      if (inputRefCountryCode.current && !inputRefCountryCode.current.contains(e.target)) {
        setShowMenu(false);
      }
    }

    window.addEventListener('click', handler);
    return () => {
      window.removeEventListener('click', handler);
    };
    
  },[]); 


  useEffect(() => {
    setSearchCountryCodeValue('');
    if (showMenu && searchRef.current) {
        searchRef.current.focus();
    }
  }, [showMenu]);


  const handleFlagButtonClick = (e) => {
    if(props.disabled) return false;
    e.stopPropagation();
    setShowMenu(!showMenu);
  };


  function onInputValueChange(event) {
    setValue(event.target.value);
    onChange(props, event.target.value);
  }

  function validate(event) {
    // construct input value after change
    const inputValueAfterEvent = event.target.value.substr(0, event.target.selectionStart) + event.data + event.target.value.substr(event.target.selectionEnd);
    if (!phoneRegex.test(inputValueAfterEvent)) {
      event.preventDefault();
    }
  }


  // Helper function to convert SVG strings to JSX elements
  const createSvgElement = (svgString) => {
    return React.createElement('svg', {
      dangerouslySetInnerHTML: { __html: svgString },
    });
  };



  const getDisplay = () => {
    return createSvgElement(selectedCountryCodeValue?.flag ?? GlobeSVG);
  };


  const onItemClick = (option) => {
    const newNumber = (option.code + (selectedCountryCodeValue ? value.replace(selectedCountryCodeValue.code, '') : value.replace(/\+/g, '')));
    setValue(newNumber);
    onChange(props, newNumber);
    setselectedCountryCodeValue(option);
    setShowMenu(false);
  };



  const isSelected = (option) => {
    return selectedCountryCodeValue?.id === option.id
  }


  const onSearch = (e) => {
    setSearchCountryCodeValue(e.target.value);
  };



  const countriesLowerCase = useMemo(() => {
    return CountryNamesCodes.map(item => ({
      id: item.id,
      name: item.name,
      nameLowerCase: item.name.toLowerCase(),
      code: item.code,
      flag: item.flag
    }));
  }, [CountryNamesCodes]);



  const getOptions = () => {
    const searchedInput = searchCountryCodeValue.toLowerCase();
    return countriesLowerCase.filter(option => option.nameLowerCase.indexOf(searchedInput) >= 0);
  }



  return (
    <div className={!props.skipValidation && isInvalid(props) ? "is-invalid field has-float-label loadable phonenumber " : "field has-float-label loadable phonenumber "}> 
      
      
      <label className="country-code-selector">
        <div ref={inputRefCountryCode} className={(showMenu ? "flag-container container-focus" : "flag-container") + (props.disabled ? " disabled" : "")}>
          <div onClick={handleFlagButtonClick} className="flag-input">
            <div className={"svg-wrapper"}>{getDisplay()}</div>
            <div className="dropdown-tools">
            </div>
          </div>
          <Fragment rendered = {showMenu}>
            <div className="dropdown-menu-phone">
              {(
                <div className="search-box">
                  <input
                    id={props.id}
                    value={searchCountryCodeValue}
                    disabled={props.disabled}
                    type={"tel"}
                    onChange={onSearch}
                    placeholder="Search"
                  />
                </div>
              )}
              {getOptions().map((option) => (
                <div 
                  onClick={() => onItemClick(option)}
                  key={option.id} 
                  className={`dropdown-item ${isSelected(option) && "selected"}`}>
                    {option.name}
                </div>
              ))}
            </div>
          </Fragment>
        </div>
      </label>

      <label className="phonenumber-input">
        <>        
          <input
            id={props.id}
            name={props.id}
            value={value}
            disabled={props.disabled}
            type={"tel"}
            ref={inputRef}
            placeholder=" "
            maxLength={props.maxLength}
            className={!props.skipValidation && isInvalid(props) ? "is-invalid input " : "input "}
            onBeforeInput={validate}
            onChange={onInputValueChange}
            onBlur={onBlur.bind(null, props)}
          />

          <span>{props.label}</span>

          {props.icon && (
            <div className={`right-decoration fz ${props.icon}`}></div>)}
        </>
      </label>

      <div className="error-icon fz fz-exclamation-triangle solid">
        <div className="has-tooltip danger" data-tooltip={errorMessage(props)}/>
      </div>
    </div>
  );
}

PhoneNumber.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  focus: PropTypes.bool,
  isInvalid: PropTypes.bool,
  skipValidation: PropTypes.bool,
  invalidMessage: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  formField: PropTypes.object,
  maxLength: PropTypes.number,
};

export default PhoneNumber;
